import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NewslistingComponent } from './pages/news-listing/news-listing.component';
import { SingleNewsComponent } from './pages/single-news/single-news.component';
import { ForgetUserComponent } from './pages/forget-user/forget-user.component';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';
import { CallUsComponent } from './pages/call-us/call-us.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { SecureFileUploadComponent } from './pages/secure-file-upload/secure-file-upload.component';
import { DynamicPageLoaderComponent } from './pages/dynamic-page-loader/dynamicPageLoader.component';
import { AuthorizationCanActivateGuard } from './core/guards/authorization.guard';
import { AuthenticationCanActivateGuard } from './core/guards/authentication.guard';
import { AuthCallBackComponent } from './pages/auth-call-back/auth-call-back.component';
import { SilentCallBackComponent } from './pages/silent-call-back/silent-call-back.component';
import { MFAEnrollmentComponent } from './pages/MFA/mfaenrollment/mfaenrollment.component';
import { MFAChallengeFactorComponent } from './pages/MFA/mfachallenge-factor/mfachallenge-factor.component';
import { LatestRatesComponent } from './pages/latest-rates/latest-rates.component';
import { ContactComponent } from './pages/contact/contact.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { MfaGuard } from './core/guards/mfa.guard';
import { UserAdminComponent } from './pages/user-admin/user-admin.component';
import { PageNotFoundComponent } from './pages/error-pages/page-not-found/page-not-found.component';
import { AdminAuthorizationCanActivateGuard } from './core/guards/admin.authorization.guard';
import { BobRemoteComponent } from './pages/bob-remote/bob-remote.component';
import { BobEmulateComponent } from './pages/bob-emulate/bob-emulate.component';
import { BobErrorComponent } from './pages/bob-error/bob-error.component';
import { SearchComponent } from './pages/search/search.component';
import { EmulateUserComponent } from './pages/emulate-user/emulate-user.component';
import { PersonalInformationComponent } from './pages/idp/personal-information/personal-information.component';
import { PinEntryComponent } from './pages/idp/pin-entry/pin-entry.component';
import { SecurityQuestionComponent } from './pages/idp/security-question/security-question.component';
import { BypasscodeComponent } from './pages/bypasscode/bypasscode.component';
import { InternalServerErrorComponent } from './pages/error-pages/internal-server-error/internal-server-error.component';
import { NoAccessComponent } from './pages/error-pages/no-access/no-access.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { AccessDelegationComponent } from './pages/aad-pages/access-delegation/access-delegation/access-delegation.component';
import { GrantUserComponent } from './pages/aad-pages/grant-user/grant-user.component';
import { TermsAndConditionsComponent } from './pages/aad-pages/terms-and-conditions/terms-and-conditions.component';

export const routes: Routes = [
  { path: 'login', component: SignInComponent, title: 'Login' }, // Define route for login
  {
    path: '', // Default route
    redirectTo: '/advisor',
    pathMatch: 'full', // pathMatch set to 'full' to ensure it matches the whole URL
  },
  {
    path: 'advisor', // Define route for advisor dashboard
    component: DashboardComponent, // Dashboard component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'TruStage | Advisor Home',
  },
  {
    path: 'advisor/news', // Define route for news listing
    component: NewslistingComponent, // News listing component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'News',
  },
  {
    path: 'advisor/news/:name', // Define route for single news
    component: SingleNewsComponent, // Single news component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
  },
  {
    path: 'user-profile/forgot-username',
    component: ForgetUserComponent,
  },
  {
    path: 'user-profile/forgot-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'user-profile/call-us',
    component: CallUsComponent,
    title: 'Call Us',
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'advisor/secure-file-upload', // Define route for secure file upload
    component: SecureFileUploadComponent, // Secure file upload component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'Secure File Upload Page',
  },
  {
    path: 'silent-callback',
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    runGuardsAndResolvers: 'always',
    pathMatch: 'full',
    component: SilentCallBackComponent,
  },
  {
    path: 'auth-redirect',
    component: AuthCallBackComponent,
  },
  {
    path: 'advisor/mfa',
    component: MFAEnrollmentComponent, // MFA enrollment component
    title: 'Enrollment',
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard],
  },
  {
    path: 'advisor/mfa/challenge',
    component: MFAChallengeFactorComponent, // MFA challenge factor component
    title: 'Two-Step Security Code',
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard],
  },
  {
    path: 'BOB-Landing',
    component: BobRemoteComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'TruStage | Book of Business',
  },
  {
    path: 'BOB-Landing/emulate',
    component: BobEmulateComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'TruStage | Book of Business',
  },
  {
    path: 'BOB-Landing/emulate/:agentNum',
    component: BobRemoteComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'TruStage | Book of Business',
  },
  {
    path: 'BOB-Landing/contracts',
    component: BobRemoteComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'TruStage | Book of Business',
  },
  {
    path: 'BOB-Landing/error',
    component: BobErrorComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'TruStage | Book of Business',
  },
  {
    path: 'advisor/profile', // Define route for user profile
    component: UserProfileComponent, // User profile component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'TruStage | User Profile',
  },
  {
    path: 'advisor/latest-rates', // Define route for latest rates
    component: LatestRatesComponent, // Latest rates component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'TruStage | Latest Rates',
  },
  {
    path: 'advisor/contact', // Define route for contact
    component: ContactComponent, // Contact component will be loaded
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    title: 'TruStage | Contact',
  },
  {
    path: 'internal-tools/user-admin', // Define route for user administration
    component: UserAdminComponent, // User admin component will be loaded
    title: 'User Administration',
    canActivate: [
      AuthenticationCanActivateGuard,
      AuthorizationCanActivateGuard,
      MfaGuard,
      AdminAuthorizationCanActivateGuard,
    ], // Guards to protect this route
  },
  {
    path: 'internal-tools/emulate-user', // Define route for user administration
    component: EmulateUserComponent, // User admin component will be loaded
    title: 'emulate',
    canActivate: [
      AuthenticationCanActivateGuard,
      AuthorizationCanActivateGuard,
      MfaGuard,
      AdminAuthorizationCanActivateGuard,
    ], // Guards to protect this route
  },
  {
    path: 'user-profile/forgot-username',
    component: ForgetUserComponent,
  },
  {
    path: 'user-profile/personal-information',
    component: PersonalInformationComponent,
    title: 'Personal Information',
  },
  {
    path: 'user-profile/pin-entry',
    component: PinEntryComponent,
    title: 'Passcode',
  },
  {
    path: 'user-profile/security-question',
    component: SecurityQuestionComponent,
    title: 'Security Question',
  },
  {
    path: 'advisor/idp/bypass-code',
    component: BypasscodeComponent,
    title: 'Bypass Code Entry',
  },
  {
    path: 'advisor/resources/:page',
    component: DynamicPageLoaderComponent, // Dynamic page loader component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
  },
  {
    path: 'advisor/resources/:page/:subpage',
    component: DynamicPageLoaderComponent, // Dynamic page loader component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
  },
  {
    path: 'advisor/promos/:page',
    component: DynamicPageLoaderComponent, // Dynamic page loader component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
  },
  {
    path: 'advisor/promos/:page/:subpage',
    component: DynamicPageLoaderComponent, // Dynamic page loader component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
  },
  {
    path: 'advisor/search',
    component: SearchComponent, // Search component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard], // Guards to protect this route
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'delegate-user',
    component: AccessDelegationComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'Trustage | Access Delegation',
  },
  {
    path: 'grant-user',
    component: GrantUserComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'Trustage | Grant User',
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'Trustage | Grant User',
  },
  {
    path: 'error-not-found-404', // Define route for page not found
    component: PageNotFoundComponent, // Page not found component will be loaded
    title: 'Page Not Found',
  },
  {
    path: 'server-error',
    component: InternalServerErrorComponent, // Search component
    canActivate: [AuthenticationCanActivateGuard, AuthorizationCanActivateGuard, MfaGuard],
    title: 'Server Error',
  },
  {
    path: 'access-denied',
    component: NoAccessComponent, // Search component
    title: 'Access Denied',
  },
  {
    path: '**',
    redirectTo: '/error-not-found-404', // Redirect to advisor dashboard
  },
];
